import React, { useEffect, useState } from 'react';
import productimg from '../Assets/images/product image 2.png';
import { Button, IconButton, Skeleton, Box } from '@mui/material';
import outerCircle from '../Assets/images/Discount tag.png'
import WellnessStore from '../DataRepo/WellnessStore';
import ShopStore from '../DataRepo/ShopStore';
import { useNavigate } from 'react-router-dom';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import doom from '../Assets/images/product doom.png'
import useCartStore from '../DataRepo/CartStore';
import productlan1 from '../Assets/images/product1_landingcard_shop.png'
import productlan4 from '../Assets/images/product4_landingcard_shop.png'
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import WishlistStore from '../DataRepo/WishlistStore';
import { getUserDetails } from '../Auth/AuthUtil';

function ShopScreen() {
    const { Selected_Wellness, getSelected_Wellness } = WellnessStore();
    const { recommedatedproducts, getTopProducts, isRecommendatedProductloading, getrecommedatedProducts, isLoading, Top_Products, isTeaProductsLoading, getProductsTeaProducts, TeaProducts } = ShopStore();
    const { addWishlist, WishlistItems, isWishlistLoading, removeWishlist, getWishlistItems } = WishlistStore()
    const { addItem, cartItems, updateQuantity, decreaseQuantity, removeItem, getCart } = useCartStore();

    const navigate = useNavigate()

    const userDetails = getUserDetails()

    useEffect(() => {
        getSelected_Wellness();
    }, []);

    useEffect(() => {
        getrecommedatedProducts()
        getTopProducts()
        getProductsTeaProducts()
        getCart()
        getWishlistItems()
    }, [])

    const landingimg = [
        {
            img: productlan1,
            id: "16516556",
        },

        // {
        //     img: productlan2,
        //     id: "16826069"
        // },

        // {
        //     img: productlan3,
        //     id: "43923568558304"
        // },

        {
            img: productlan4,
            id: "622"
        },

        // {
        //     img: productlan5,
        //     id: "16842249"
        // }
    ]

    const [currentIndex, setCurrentIndex] = useState(0);

    const [allWellnessCategories, setWellnessCategories] = useState([
        {
            name: "Respiratory",
            imageUrl: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/Respiratoty.png",
            selected: false
        },
        {
            name: "Mental",
            imageUrl: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/Mental.png",
            selected: false
        },
        {
            name: "Gastro",
            imageUrl: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/Gastro.png",
            selected: false
        },
        {
            name: "Hair & Skin",
            imageUrl: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/Hair+%26amp%3B+Skin.png",
            selected: false
        },
        {
            name: "Physical",
            imageUrl: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/Physical.png",
            selected: false
        },
        {
            name: "Women",
            imageUrl: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/Women.png",
            selected: false
        },
        {
            name: "Sexual",
            imageUrl: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/Sexual.png",
            selected: false
        },
        {
            name: "Metabolic",
            imageUrl: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/Metabolic.png",
            selected: false
        },
        {

            name: "General",
            imageUrl: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/General_wellness.png",
            selected: false
        }
    ]);

    const addtoCart = (item, id) => {

        const price = parseInt(item?.price)

        const desc = item?.desc

        const qty = item?.qty

        let product = {
            id: id,
            productName: item?.name,
            quantity: 1,
            price,
            desc,
            companyid: item?.company_id,
            deliverycharges: item?.deliverycharges,
            src: item?.imgurl,
            actualQty: qty,
            sku: item?.sku,
            company: item?.company
        };

        addItem(product, userDetails?.UID)
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex === landingimg.length - 1 ? 0 : prevIndex + 1
            );
        }, 3000);
        return () => clearInterval(interval);
    }, [landingimg.length]);

    return (
        <div className='Shop-main-section'>
            <div className='Shop-promo-card' onClick={() => { navigate(`/Product?id=${landingimg[currentIndex]?.id}`) }}>
                <div className='Shop-promo-card-title'>
                    <p>Natural supplement</p>
                    <p>for sugar control</p>
                    <div>
                        <Button
                            style={{
                                width: '100%',
                                textTransform: 'none',
                                borderRadius: '5px',
                                backgroundColor: '#FDFDFD',
                                color: '#75623F',
                                border: 'none',
                                boxSizing: 'border-box',
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 500,
                                padding: '10px'
                            }}
                            onClick={() => { navigate(`/Product?id=${landingimg[currentIndex]?.id}`) }}
                        >
                            Buy now
                        </Button>
                    </div>
                </div>

                {/* <div className="outer-circle-container">
                    <div className="outer-circle-wrapper">
                        <div className="outer-circle-image">
                            <img src={outerCircle} alt="Outer Circle" />
                        </div>
                        <div className="text-overlay">
                            <p>Get</p>
                            <p>5%</p>
                            <p>Offer</p>
                        </div>
                    </div>
                </div> */}

                <div className='flex flex-col items-center'>
                    <img src={landingimg[currentIndex].img}></img>
                    <img src={doom} />
                </div>

            </div>

            {allWellnessCategories?.length > 0 &&
                <div className='Shop-Wellness-Categories mt-3'>
                    <div className='shop-selected-wellness-categories mt-2 flex justify-between flex-wrap gap-4'>
                        {allWellnessCategories?.map((category, index) => (
                            <div
                                key={index}
                                className='WellnessCard flex flex-col items-center cursor-pointer'
                                onClick={() => {
                                    navigate(`/Products?category=${category?.name}`)
                                }}
                            >
                                <div className='WellnessImg'>
                                    <img src={category.imageUrl} alt={category.name} />
                                </div>
                                
                                <p className='mt-2 text-center'>
                                    {category.name}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            }

            <div className='RecommendedProduct-section'>
                {recommedatedproducts.length > 0 && <div className='flex flex-row justify-between items-center w-full'>
                    <p>Recommended Products</p>
                    {recommedatedproducts.length > 6 && <p id='viewAll' onClick={() => {
                        navigate('/RecommendedProducts')
                    }}>View all</p>}
                </div>
                }
                <div className='RecommendedProduct-container'>
                    {isRecommendatedProductloading ? (

                        Array.from({ length: 6 }).map((_, i) => (
                            <div key={i} className='Product-section-card'>
                                <Skeleton variant="rectangular" width='100%' height={118} />
                                <Skeleton width="100%" />
                                <Skeleton width="80%" />
                                <Skeleton width="40%" />
                            </div>
                        ))
                    ) : (

                        recommedatedproducts?.slice(0, 6).map((product, i) => (
                            <div key={product} className='Product-section-card' onClick={() => navigate(`/Product?id=${product?.id}`)}>
                                <div className="Product-card-header">
                                    {/* <div className="Product-discount-badge">
                                        {e.orgprice > 0 && e.orgprice != e.price ? (
                                            <p>
                                                {(((parseFloat(e.orgprice) - parseFloat(e.price)) / parseFloat(e.orgprice)) * 100).toFixed(0) + "% off"}
                                            </p>
                                        ) : null}
                                    </div> */}
                                    {/* <div className="Product-wishlist-icon">
                                        <IconButton
                                            onClick={(event) => {
                                                event.stopPropagation();
                                                {
                                                    WishlistItems.some((item) => item.id === e?.id) ? (
                                                        removeWishlist(e.id)
                                                    ) : (
                                                        addWishlist(e.id)
                                                    )
                                                }
                                            }}
                                        >
                                            {WishlistItems.some((item) => item.id === e?.id) ? (
                                                <FavoriteIcon style={{
                                                    color: "#DA6E0B"
                                                }} />
                                            ) : (
                                                <FavoriteBorderIcon />
                                            )}
                                        </IconButton>
                                    </div> */}
                                </div>

                                <div>
                                    <img src={product?.imgurl} alt={product?.name} />
                                </div>

                                <div className='Product-section-card-title'>
                                    <p>{product?.name}</p>
                                    <p>{product?.desc}</p>
                                </div>

                                <div className='Addtobagbutton'>
                                    <div className='Product-section-price-details flex gap-5'>
                                        {/* {e?.orgprice > 0 && <p className=''><del>{`₹ ${e?.orgprice}`}</del></p>} */}
                                        <p>₹ {product?.price}</p>
                                    </div>
                                    <div className='w-100'>
                                        <Button
                                            style={{
                                                width: '100%',
                                                textTransform: 'none',
                                                backgroundColor: product.onsale ? '#75623F' : '#D9d9d9',
                                                color: product.onsale ? 'white' : "#A5A39D",
                                                display: "block",
                                                border: 'none',
                                                boxSizing: 'border-box',
                                                borderRadius: "5px",
                                                fontFamily: "'Poppins', sans-serif",
                                                fontWeight: 500,
                                                padding: "8px"
                                            }}
                                            onClick={(event) => {
                                                event.stopPropagation();
                                                if (product.onsale) {
                                                    const existingItem = cartItems?.find(cartItem => cartItem?.id === product.id);
                                                    const id = product?.id
                                                    !existingItem && addtoCart(product, id)
                                                }

                                            }}
                                        >
                                            <div className="addtobagctn">
                                                {(() => {

                                                    if (product.onsale) {
                                                        const existingItem = cartItems?.find(cartItem => cartItem?.id === product.id);
                                                        return (
                                                            <div>
                                                                {existingItem ? (
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            alignItems: "center",

                                                                            justifyContent: "space-evenly",
                                                                        }}
                                                                    >
                                                                        <RemoveIcon
                                                                            style={{ cursor: "pointer" }}
                                                                            fontSize='small'
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();

                                                                                const id = product?.id?.toString() || product?.id;

                                                                                existingItem.quantity <= 1 ?
                                                                                    removeItem(id) : decreaseQuantity(id, userDetails?.UID);
                                                                            }}
                                                                        />
                                                                        <span >{existingItem.quantity}</span>
                                                                        <AddIcon
                                                                            style={{ cursor: "pointer" }}
                                                                            fontSize='small'
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                const id =
                                                                                    product?.id?.toString() || product?.id;
                                                                                updateQuantity(id, userDetails?.UID);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <p>Add to Bag</p>
                                                                )}
                                                            </div>
                                                        );
                                                    } else {
                                                        return <p>Coming Soon</p>;
                                                    }
                                                })()}
                                            </div>

                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>

            <div>
                <div className='TeaProductsHeading'>
                    <p>Immune Boosters</p>
                </div>
                <div className='TeaProductsContainer'>
                    {isTeaProductsLoading ? [...Array(6)].map((_, index) => (
                        <Box
                            key={index}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: 2,
                                p: 2,
                                bgcolor: "white",
                                borderRadius: 2,
                                boxShadow: 3,
                                width: 180,
                                height: 450,
                            }}
                        >
                            {/* Image Skeleton */}
                            <Skeleton variant="rectangular" width={'100%'} height={220} />

                            {/* Text Skeleton */}
                            <Box sx={{ width: "100%", textAlign: "center" }}>
                                <Skeleton variant="text" width="80%" height={20} />
                                <Skeleton variant="text" width="60%" height={20} />
                                <Skeleton variant="text" width="50%" height={20} />
                            </Box>
                        </Box>
                    )) :

                        TeaProducts.map((e, i) => {
                            return <div >
                                <div style={{ backgroundColor: "#red" }}>
                                    <img src={e.imgurl} style={{ mixBlendMode: "multiply", backgroundColor: "red" }}></img>
                                </div>
                                <div className='TeaPID' onClick={() => {
                                    navigate(`/Product?id=${e?.id}`)
                                }}>
                                    <div className='flex flex-row items-center justify-between'>
                                        <div>
                                            <p>{e.name}</p>
                                        </div>

                                        <div className="Product-wishlist-icon">
                                            <IconButton
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    {
                                                        WishlistItems.some((item) => item.id === e?.id) ? (
                                                            removeWishlist(e.id)
                                                        ) : (
                                                            addWishlist(e.id)
                                                        )
                                                    }
                                                }}
                                            >
                                                {WishlistItems.some((item) => item.id === e?.id) ? (
                                                    <FavoriteIcon style={{
                                                        color: "#DA6E0B"
                                                    }} />
                                                ) : (
                                                    <FavoriteBorderIcon />
                                                )}
                                            </IconButton>
                                        </div>

                                    </div>

                                    <div>
                                        <p>QTY : {e.qty}</p>
                                    </div>

                                    <div>
                                        <p>{e?.desc}</p>
                                    </div>

                                    <div className='flex items-center justify-between w-100 gap-10'>
                                        <div className='Product-section-price-details'>
                                            {e?.orgprice > 0 && e?.orgprice != e?.price &&
                                                <p className='mr-5' style={{ fontSize: "16px" }}><del>{`₹ ${e?.orgprice}`}</del></p>}
                                            <p style={{ fontSize: "18px" }}>₹ {e?.price}</p>
                                        </div>
                                        <div className='w-100' style={{ flex: 1 }}>
                                            <Button
                                                style={{
                                                    width: '100%',
                                                    textTransform: 'none',
                                                    backgroundColor: e?.onsale ? '#75623F' : '#D9d9d9',
                                                    color: e?.onsale ? 'white' : "#A5A39D",
                                                    display: "block",
                                                    border: 'none',
                                                    boxSizing: 'border-box',
                                                    borderRadius: "5px",
                                                    fontFamily: "'Poppins', sans-serif",
                                                    fontWeight: 500,
                                                    padding: "8px"
                                                }}
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    const product = e
                                                    if (product.onsale) {
                                                        const existingItem = cartItems?.find(cartItem => cartItem?.id === product.id);
                                                        const id = product?.id
                                                        !existingItem && addtoCart(product, id)
                                                    }

                                                }}
                                            >
                                                <div className="addtobagctn">
                                                    {(() => {
                                                        const product = e
                                                        if (product.onsale) {
                                                            const existingItem = cartItems?.find(cartItem => cartItem?.id === product.id);
                                                            return (
                                                                <div>
                                                                    {existingItem ? (
                                                                        <div
                                                                            style={{
                                                                                display: "flex",
                                                                                alignItems: "center",

                                                                                justifyContent: "space-evenly",
                                                                            }}
                                                                        >
                                                                            <RemoveIcon
                                                                                style={{ cursor: "pointer" }}
                                                                                fontSize='small'
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();

                                                                                    const id = product?.id?.toString() || product?.id;

                                                                                    existingItem.quantity <= 1 ?
                                                                                        removeItem(id) : decreaseQuantity(id, userDetails?.UID);
                                                                                }}
                                                                            />
                                                                            <span >{existingItem.quantity}</span>
                                                                            <AddIcon
                                                                                style={{ cursor: "pointer" }}
                                                                                fontSize='small'
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    const id =
                                                                                        product?.id?.toString() || product?.id;
                                                                                    updateQuantity(id, userDetails?.UID);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    ) : (
                                                                        <p>Add to Bag</p>
                                                                    )}
                                                                </div>
                                                            );
                                                        } else {
                                                            return <p>Coming Soon</p>;
                                                        }
                                                    })()}
                                                </div>

                                            </Button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        })
                    }
                </div>
            </div>

            <div className='mt-5 Top-Products-landing-section'>
                <div>
                    <p>Top Products</p>
                    <p style={{ cursor: "pointer" }} onClick={() => {
                        navigate('/Products?type=All')
                    }}>View all</p>
                </div>
                <div>
                    {
                        Top_Products.map((e, i) => {
                            return <div className='Top-Products-landing-sectionpcard' key={i} onClick={() => {
                                navigate(`/Product?id=${e?.id}`)
                            }}>
                                <div>
                                    <img src={e?.imgurl}></img>
                                </div>

                                <div>
                                    <p>{e?.name}</p>

                                    {e?.company_id != '1005' && <p>{e?.desc}</p>}

                                    <div className='Product-section-price-details flex gap-5'>
                                        {/* {e?.orgprice > 0 && <p className=''><del>{`₹${e?.orgprice}`}</del></p>} */}
                                        <p>₹ {e?.price}</p>
                                    </div>


                                    {
                                        !e.onsale &&
                                        <div>
                                            <Button

                                                style={{
                                                    width: '100%',
                                                    textTransform: 'none',
                                                    backgroundColor: '#D9d9d9',
                                                    color: "#A5A39D",
                                                    border: 'none',
                                                    fontSize: "medium",
                                                    boxSizing: 'border-box',
                                                    borderRadius: "5px",
                                                    fontFamily: "'Poppins', sans-serif",
                                                    fontWeight: 500,
                                                    padding: "5px"
                                                }}
                                            >

                                                Out of Stock
                                            </Button>
                                        </div>
                                    }

                                </div>



                            </div>
                        })
                    }
                </div>
            </div>

            {/* <div className='mt-10'>
                <div className='Slot-errreponse'>

                    <div className='flex flex-col items-center'>
                        <img src={cautionimg}></img>
                        <p style={{ fontWeight: 500, fontSize: 'large' }}>Disclaimer</p>
                    </div>
                    <p>The assessment and suggestions provided here are for health and wellness purposes only. Please do not self-medicate. Consult an Ayurveda practitioner or medical professional for accurate guidance.</p>
                </div>
            </div> */}

        </div >
    );
}

export default ShopScreen;
